import React from 'react'
import elevation from '../../../../../lib/api/elevation'
import { waitForGoogleMaps } from '../../../../map/maploader/maploader';

let ShapeLabel;

waitForGoogleMaps(() => {
  ShapeLabel = class extends google.maps.OverlayView {
    constructor(position, content, yOffset) {
      super()
      this.position = position
      this.container = document.createElement('div')
      this.container.appendChild(content)
      this.container.classList.add('map-label')
      this.yOffset = yOffset
    }
    onAdd() {
      this.getPanes().floatPane.appendChild(this.container)
    }
    onRemove() {
      this.container.parentElement.removeChild(this.container)
    }
    draw() {
      const pxPosition = this.getProjection().fromLatLngToDivPixel(this.position)
      this.container.style.left = `${pxPosition.x}px`
      this.container.style.top = `${pxPosition.y}px`
      this.container.style.transform = `translate(-50%, ${this.yOffset}`
    }
  }
})

let shapeInfoBox;

waitForGoogleMaps(() => {
  shapeInfoBox = class extends google.maps.OverlayView {
    constructor(content, shape) {
      super();
      this.container = document.createElement('div');
      this.container.style.position = 'absolute';
      this.container.style.width = '200px';
      this.container.appendChild(content);
      this.shape = shape;
      this.updateShapeContent = this.updateShapeContent.bind(this);
      const close = document.createElement('div');
      this.container.appendChild(close);
      close.style.backgroundImage = 'url(../../../../../../../../asset/Close-X_Thin_FFFFFF_ldpi.png)';
      close.style.backgroundSize = 'contain';
      close.style.position = 'relative';
      close.style.width = '10px';
      close.style.height = '10px';
      close.style.cursor = 'pointer';
      close.style.left = '100%';
      close.style.top = '10px';
      close.style.transform = 'translate(calc(-100% - 10px))';
      close.addEventListener('click', () => {
        this.setMap(null);
      });
    }

    // Method to update the content of the info box and re-render
    updateShapeContent(shape, content, shouldRedraw = true) {
      // Clear existing content
      while (this.container.firstChild) {
        this.container.removeChild(this.container.firstChild);
      }

      // Update the shape and add new content
      this.shape = shape;
      this.container.appendChild(content);

      // Add close button again after content update
      this.addCloseButton();

      // Redraw the info box after updating content
      if (shouldRedraw) {
        this.draw();
      }
    }

    addCloseButton() {
      const close = document.createElement('div');
      this.container.appendChild(close);
      close.style.backgroundImage = 'url(../../../../../../../../asset/Close-X_Thin_FFFFFF_ldpi.png)';
      close.style.backgroundSize = 'contain';
      close.style.position = 'relative';
      close.style.width = '10px';
      close.style.height = '10px';
      close.style.cursor = 'pointer';
      close.style.left = '100%';
      close.style.top = '10px';
      close.style.transform = 'translate(calc(-100% - 10px))';
      close.addEventListener('click', () => {
        this.setMap(null);
      });
    }

    // Called when the info box is added to the map
    onAdd() {
      const panes = this.getPanes();
      panes.overlayLayer.appendChild(this.container);
    }

    // Called each time the overlay's position needs to be redrawn
    draw() {
      const overlayProjection = this.getProjection();
      let position;

      // Get the path and check its length
      if (this.shape.getPath) {
        const path = this.shape.getPath();
        const length = path.getLength();

        // Check if the path has at least one point
        if (length > 0) {
          // Use the last point in the path for positioning
          position = path.getAt(length - 1); // Get the last point
        }
      }

      // If the shape has bounds, you can also consider using them
      if (this.shape.getBounds) {
        position = this.shape.getBounds() && this.shape.getBounds().getCenter(); // Optional: You can use the center of bounds
      }

      // Convert the latLng position to pixel coordinates on the map
      if (position) {
        const point = overlayProjection.fromLatLngToDivPixel(position);
        this.container.style.left = `${point.x + 10}px`; // Position it 10px to the right of the shape
        this.container.style.top = `${point.y - 50}px`;  // Adjust the vertical offset if necessary
      }
    }

    // Called when the info box is removed from the map
    onRemove() {
      if (this.container.parentNode) {
        this.container.parentNode.removeChild(this.container);
      }
    }
  }
})

export const shapeUtils = {
  create(type, properties) {
    switch (type) {
      case 'line':
        return new google.maps.Polyline({
          strokeColor: properties.color
        })
      case 'polygon':
        return new google.maps.Polygon({
          strokeColor: properties.color,
          fillColor: properties.color
        })
      case 'circle':
        return new google.maps.Circle({
          strokeColor: properties.color,
          fillColor: properties.color,
          editable: true
        })
    }
  },
  addInfoBox(shape, entries) {
    const infoContentBox = document.createElement('div'),
      infoHeader = document.createElement('p')
    infoHeader.innerText = entries.header
    infoContentBox.appendChild(infoHeader)
    infoContentBox.classList.add('shape-infobox-container')
    infoHeader.classList.add('shape-infobox-header')

    entries.entries.forEach(entry => {
      const entryEle = document.createElement('p'),
        entryStr = entry.join(': ')
      entryEle.innerText = entryStr
      entryEle.classList.add('shape-infobox-entry')
      infoContentBox.appendChild(entryEle)
    })

    return new shapeInfoBox(infoContentBox, shape)
  },
  updateInfoBox(shape, entries, box, shouldRedraw = true) {
    const infoContentBox = document.createElement('div'),
      infoHeader = document.createElement('p');
    infoHeader.innerText = entries.header;
    infoContentBox.appendChild(infoHeader);
    infoContentBox.classList.add('shape-infobox-container');
    infoHeader.classList.add('shape-infobox-header');

    entries.entries.forEach(entry => {
      const entryEle = document.createElement('p'),
        entryStr = entry.join(': ');
      entryEle.innerText = entryStr;
      entryEle.classList.add('shape-infobox-entry');
      infoContentBox.appendChild(entryEle);
    });

    box.updateShapeContent(shape, infoContentBox, shouldRedraw);
  },
  createLabel(props) {
    const { coord, content, yOffset } = props
    return new ShapeLabel(coord, content, yOffset)
  },
  getLabelOffsets(coord1, coord2) {
    return Math.abs(coord1) < Math.abs(coord2) ? '-100%' : '0%'
  },
  addLabels(shape) {
    const path = shape.getPath()
    return path.getArray().map((coord, idx) => {
      const content = document.createElement('div'),
        copyLat = document.createElement('p'),
        copyLng = document.createElement('p'),
        yOffset = idx < path.getLength() - 1 ?
          this.getLabelOffsets(path.getAt(idx + 1).lat(), coord.lat()) :
          this.getLabelOffsets(path.getAt(idx - 1).lat(), coord.lat())
      copyLat.innerHTML = `Lat: ${Math.round(coord.lat() * 1000000) / 1000000}`
      copyLng.innerHTML = `Lng: ${Math.round(coord.lng() * 1000000) / 1000000}`
      content.appendChild(copyLat)
      content.appendChild(copyLng)
      return this.createLabel({ coord, content, yOffset })
    })
  },
  addDetailLabel(shape) {

  },
  createGeoLine(shape) {
    const coordinates = shape.getPath().getArray().map(coord => [coord.lng(), coord.lat()])
    return JSON.stringify({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates
          },
          properties: {
            line: {
              color: shape.strokeColor,
              width: 2,
              style: 'solid'
            }
          }
        }
      ]
    })
  },
  createGeoPoly(shape) {
    const coordinates = shape.getPath().getArray().map(coord => [coord.lng(), coord.lat()])
    coordinates.unshift([coordinates[coordinates.length - 1][0], coordinates[coordinates.length - 1][1]])
    return JSON.stringify({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [coordinates]
          },
          properties: {
            line: {
              color: shape.strokeColor,
              width: 2,
              fill: shape.fillColor
            }
          }
        }
      ]
    })
  },
  createGeoCircle(shape) {
    const point = shape.getCenter()
    return JSON.stringify({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [point.lng(), point.lat()]
          },
          properties: {
            line: {
              color: shape.strokeColor,
              fill: shape.fillColor,
              fillOpacity: 0.4,
              width: 2
            },
            radius: shape.getRadius()
          }
        }
      ]
    })
  },
  getArea(shape, units, ignoreCount = 0) {
    if (shape) {
      const coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount),
        scale = units === 'imperial' ? 0.000247105 : 0.0001,
        computedArea = Math.round(google.maps.geometry.spherical.computeArea(coords) * scale * 100) / 100
      return computedArea
    }
  },
  getLength(shape, units, ignoreCount = 0) {
    const denom = units === 'imperial' ? 1609.344 : 1000,
      coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount)
    let length = 0
    coords.forEach((pt, idx) => {
      if (idx > 0) {
        length += google.maps.geometry.spherical.computeDistanceBetween(pt, coords[idx - 1]) / denom
      }
    })
    return length
  },
  getElevationGain(shape, token, ignoreCount = 0) {
    const coords = shape.getPath().getArray().slice(0, shape.getPath().getLength() - ignoreCount),
      eles = coords.map(coord => elevation.getElevation(coord.lat(), coord.lng(), token))

    return new Promise((resolve, reject) => {
      Promise.all(eles)
        .then(res => {
          let gain = 0
          if (res.length > 1) {
            gain = 0
            for (let i = 0; i < res.length - 1; i++) {
              if (res[i + 1] > res[i]) {
                gain = gain + res[i + 1] - res[i];
              }
            }
          }
          resolve(gain)
        })
        .catch(err => {
          console.error('Could not fetch elevations:', err)
          reject()
        })
    })
  }
}